import React, {Fragment, useContext} from 'react';
import classNames from 'classnames';
import { ListingAppContext } from '../contexts';

export const Footer = ({
    contactUrl,
    tosUrl,
    privacyUrl,
    doNotSellUrl,
    logo,
    copyrightName,
    messages,
    dangerouslySetMessages = false,
    className,
    versionIdentifier = '',
    homeUrl = '/#',
}) => {
    const { t } = useContext(ListingAppContext);
    const year = new Date().getFullYear();

    if (dangerouslySetMessages && typeof messages !== 'string') {
        console.error('Messages should be a string when using dangerouslySetMessages');
    }

    return (
        <footer className={classNames('footer', className)}>
            <div className='footer-container org-listing__container'>
                <div className='footer-main'>
                    {!!logo && (
                        <div className="footer-branding">
                            <a
                                href={homeUrl}
                                className="footer-branding-image"
                            >
                                <img src={logo} alt={`${copyrightName} Logo`} />
                                <span className="sr-only">{copyrightName}</span>
                            </a>
                        </div>
                    )}
                    <ul className='footer-links clean'>
                        {!!contactUrl && (
                            <li><a href={contactUrl} target="_blank" rel="noopener noreferrer">{t('support')}</a></li>
                        )}
                        {!!tosUrl && (
                            <li><a href={tosUrl} target="_blank" rel="noopener noreferrer">{t('terms_of_service')}</a></li>
                        )}
                        {!!privacyUrl && (
                            <li><a href={privacyUrl} target="_blank" rel="noopener noreferrer">{t('privacy_policy')}</a></li>
                        )}
                        {!!doNotSellUrl && (
                            <li><a href={doNotSellUrl} target="_blank" rel="noopener noreferrer">{t('do_not_sell_or_share')}</a></li>
                        )}
                    </ul>
                    {!!copyrightName && (<p className='footer-copyright'>©{year} {copyrightName}</p>)}
                    {!!versionIdentifier && (
                        <p className='footer-copyright' style={{ textAlign: 'center' }}>
                          {versionIdentifier}
                        </p>
                    )}
                </div>
                {!!messages && (
                    <Fragment>
                        {dangerouslySetMessages && typeof messages === 'string'  ? (
                            <p dangerouslySetInnerHTML={{ __html: messages }} />
                        ) : (
                            <p>{messages}</p>
                        )}
                    </Fragment>
                )}
            </div>
        </footer>
    );
}
